import { useEffect, useState } from "react";
import { Circle } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";

export const LiveListeners = () => {
  const [listenerCount, setListenerCount] = useState(0);
  const [displayCount, setDisplayCount] = useState(0);

  useEffect(() => {
    const channel = supabase.channel('live-listeners', {
      config: {
        presence: {
          key: Math.random().toString(36).substring(7),
        },
      },
    });

    channel
      .on('presence', { event: 'sync' }, () => {
        const state = channel.presenceState();
        const count = Object.keys(state).length;
        setListenerCount(count);
      })
      .subscribe(async (status) => {
        if (status === 'SUBSCRIBED') {
          await channel.track({
            online_at: new Date().toISOString(),
          });
        }
      });

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  useEffect(() => {
    // Seeded random function for consistency across all users
    const seededRandom = (seed: number) => {
      const x = Math.sin(seed) * 10000;
      return x - Math.floor(x);
    };

    // Update every 30 seconds for natural fluctuation
    const updateDisplay = () => {
      if (listenerCount < 50) {
        // Use time-based seed that changes every 30 seconds
        const timeSeed = Math.floor(Date.now() / 30000);
        // Generate base number between 15-45 for realistic range
        const baseCount = Math.floor(seededRandom(timeSeed) * 31) + 15;
        // Add slight variation based on seconds for smooth transitions
        const variation = Math.floor(seededRandom(timeSeed + 1) * 5) - 2;
        const finalCount = Math.max(1, Math.min(50, baseCount + variation));
        setDisplayCount(finalCount);
      } else {
        setDisplayCount(listenerCount);
      }
    };

    updateDisplay();
    const interval = setInterval(updateDisplay, 5000); // Update every 5 seconds

    return () => clearInterval(interval);
  }, [listenerCount]);

  return (
    <div className="flex items-center gap-2 text-foreground/80">
      <Circle className="h-2 w-2 fill-red-500 text-red-500 animate-pulse" />
      <span className="text-sm font-medium">
        {displayCount} {displayCount === 1 ? 'listener' : 'listeners'} live
      </span>
    </div>
  );
};
